import { parsePasskeyReturn as e, passkeyReturnKeys as t } from "./parsePasskeyReturn.mjs";
//#region src/passkeys/native/passkeyReturnSlot.ts
var n = null, r = null, i = !1, a = (e) => {
	n = e, r = null;
}, o = (a, o) => {
	r = {
		attemptHandle: n,
		result: e(a)
	}, !i && o && (i = !0, o(t(a)));
}, s = (e) => {
	let t = r;
	return r = null, !t || t.attemptHandle !== e ? null : t.result;
}, c = () => {
	n = null, r = null;
}, l = () => {
	n = null, r = null, i = !1;
};
//#endregion
export { a as armPasskeyReturn, c as clearPasskeyReturn, o as parkPasskeyReturn, l as resetPasskeyReturnSlot, s as takePasskeyReturn };
